import './BusinessInformation.css';

export default function BusinessInformation() {
  return <section className="business-information" aria-label="사업자 정보">
    <h2 className="business-company-name">지현창의 주식회사 <span>(지현창의(주))</span></h2>
    <dl className="business-details">
      <div><dt>대표자</dt><dd>김지수</dd></div>
      <div><dt>사업자등록번호</dt><dd>549-81-02953</dd></div>
      <div><dt>통신판매업신고번호</dt><dd>2026-충북청주-1142</dd></div>
      <div><dt>설립일</dt><dd>2023년 11월 8일</dd></div>
      <div className="business-detail-wide"><dt>주소</dt><dd>충청북도 청주시 흥덕구 풍산로 178번길 42, 1층 101호 (복대동)</dd></div>
      <div className="business-detail-wide"><dt>연락처</dt><dd><a href="mailto:dnqlsdnqls529@orinan.kr">dnqlsdnqls529@orinan.kr</a></dd></div>
    </dl>
  </section>;
}
